<template>
    <div v-if="item.text"
         class="draft-org-flag"
         style="color: red;text-align: center;transform-origin:top left;-webkit-transform-origin: left top;"
         :style="{'font-weight':item.bold?'bold':'',
         'font-family':item.font,
         'letter-spacing':item.letterSpace?item.letterSpace+'pt':'0pt',
         'width':item.scale?100/item.scale+'%':'100%',
         'font-size':item.fontSize,
         'transform':'scalex('+item.scale+')',
         '-webkit-transform':'scalex('+item.scale+')'}">
        <div :style="{'text-align-last':item.align}"
             v-for="(text,index) in item.text.split('\n')" :key="index">
            {{text}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "DraftOrgFlag",
        props: {
            item: {
                text: null,
                bold: null,
                font: null,
                letterSpace: null,
                scale: null,
                fontSize: null,
                align: null
            }
        }
    }
</script>